import { render } from "./ObjectiveDeleteModal.vue?vue&type=template&id=40067b54&scoped=true"
import script from "./ObjectiveDeleteModal.vue?vue&type=script&lang=js"
export * from "./ObjectiveDeleteModal.vue?vue&type=script&lang=js"

import "./ObjectiveDeleteModal.vue?vue&type=style&index=0&id=40067b54&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40067b54"]])

export default __exports__